import { ChargeDetailConstant } from "presentation/constant/ChargeDetailMaintenance/ChargeDetailConstant";
import { useChargeDetailVM } from "presentation/hook/ChargeDetailMaintenance/useChargeDetailVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useChargeDetailTracked } from "presentation/store/ChargeDetailMaintenance/ChargeDetailProvider";
import { useChargeHeaderMaintenanceTracked } from "presentation/store/ChargeHeaderMaintenance/ChargeHeaderMaintenanceProvider";
import { useCallback, useState } from "react";
import { HPHButton, IconButton, Loader } from "veronica-ui-component/dist/component/core";
import { SidebarActionBar, SidebarActionCross, SidebarTitle, Sidebarheader } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";
import ChargeSearchForm from "./ChargeSearchForm";

const ChargeSearchPanel = () => {
    const CHARGEDETAIL_CONSTANT = ChargeDetailConstant.Charge;
    const chargeDetailVM = useChargeDetailVM();
    const messageBarVM = useMessageBarVM();
    const [chargeDetailState] = useChargeDetailTracked();
    const [chargeHeaderState] = useChargeHeaderMaintenanceTracked();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const chargeHeader = chargeHeaderState?.currentChargeHeader ? chargeHeaderState?.currentChargeHeader : chargeDetailState?.currentChargeHeader;

    const closeButtonClicked = useCallback(() => {
        chargeDetailVM.onSearchClick();
    }, [chargeDetailVM]);

    const resetButtonClicked = useCallback(() => {
        chargeDetailVM.onSearchCriteriaResetClick();
    }, [chargeDetailVM]);

    const searchButtonClicked = useCallback(() => {
        setIsLoading(true);
        chargeDetailVM.setIsSearchLoading(true);
        const criteria = { ...chargeDetailState.searchCriteria, chargeHdrId: Number(chargeHeader?.id) ?? 0 }
        chargeDetailVM.getChargeDetails(criteria).then((data) => {
            setIsLoading(false);
            chargeDetailVM.setIsSearchLoading(false);
            if (data && data["chargeDetailSearchFail"]) {
                const err: string = data["chargeDetailSearchFail"]?.toString() ?? "";
                messageBarVM.showError(err.replace("Error:", ""), true);
            }
        }).catch(error => {
            setIsLoading(false);
            chargeDetailVM.setIsSearchLoading(false);
        })

    }, [chargeDetailState.searchCriteria, chargeDetailVM, chargeHeader?.id, messageBarVM])

    return (
        <div className='side-form-content-left-wrapper' style={{ padding: "20px 20px 20px 0px", display: 'flex', flexDirection: 'column', height: 'calc(100vh - 10vh - 62px)' }}>

            <div className={'flex-row'}>
                <div className={'flex-row-item flex-row-item-full-width'}>
                    <Sidebarheader>
                        <SidebarTitle>{CHARGEDETAIL_CONSTANT.SEARCH_CRITERIA}</SidebarTitle>

                        <SidebarActionCross>
                            <IconButton
                                fileName="Icon-cross" size="medium" toolTipText='Close' toolTipArrow={false} onClick={closeButtonClicked} />
                        </SidebarActionCross>
                    </Sidebarheader>
                </div>
            </div>
            {isLoading &&
                <Loader Indicator="Spinner" size="Medium" />
            }

            <div className={'add-edit-form'} style={{ maxHeight: '68vh', height: '68vh', overflow: 'auto' }}>
                <div className="flex-row-auto">
                    <div className={'flex-row-item'}>

                        {/* Stack Form Start */}
                        <ChargeSearchForm />
                    </div>
                </div>
            </div>
            <SidebarActionBar>
                <HPHButton label={'Reset'} size={'Small'} theme={'Secondary'} onClick={resetButtonClicked} />
                <HPHButton label={'Search'} size={'Small'} theme={'Primary'} onClick={() => searchButtonClicked()} />
            </SidebarActionBar>
        </div>
    );
}

export default ChargeSearchPanel;